import React from 'react'
import GenericReport from '../GenericReport'

const AdvisorPerformancePage: React.FC = () => {
  return <GenericReport reportId={8} />
}

export default AdvisorPerformancePage
